export function reorderTreeList(e, actions) {
    const { draggedOver, dragged } = e;
    let draggedOverElement, draggedElement, isBetween = false, shouldAllowDrop = true;

    const data = actions.slice();

    if (draggedOver.length === 1) {
        draggedOverElement = data[draggedOver[0]];
    } else {
        draggedOverElement =
            data[draggedOver[0]].actions[draggedOver[1]];
    }

    if (dragged.length === 1) {
        draggedElement = data[dragged[0]];
    } else {
        draggedElement =
            data[dragged[0]].actions[dragged[1]];
    }

    if (draggedOverElement.actionDisplay === "Button Group") {
        let row = e.nativeEvent.target;
        let coord = row.getBoundingClientRect();
        let { clientY } = e.nativeEvent;
        let coordElementMiddle = coord.top + coord.height / 2;
        let coordMiddleDiff = coordElementMiddle - clientY;
        isBetween = coordMiddleDiff < 5 && coordMiddleDiff > -5;
    }

    if (
        draggedElement.actionDisplay === "Button Group" &&
        (isBetween || draggedOver.length === 2)
    ) {
        shouldAllowDrop = false;
    }

    if (draggedOverElement.actionDisplay === "Button Group" && draggedOverElement.actions === undefined) {
        draggedOverElement.actions = [];
    }

    if (isBetween) {
        if (dragged.length === 1) {
            // this line is intentionally copied
            // place it below else if to know why.
            data[draggedOver[0]].actions.push(draggedElement);
            data.splice(dragged[0], 1);
        } else if (dragged.length === 2) {
            data[dragged[0]].actions.splice(dragged[1], 1);
            data[draggedOver[0]].actions.push(draggedElement);
        }
    } else if (dragged[0] > draggedOver[0]) {
        if (dragged.length === 2 && draggedOver.length === 1) {
            data[dragged[0]].actions.splice(dragged[1], 1);
            data.splice(draggedOver[0], 0, draggedElement);
        } else if (draggedOver.length === 2 && dragged.length === 1) {
            data[draggedOver[0]].actions.splice(draggedOver[1], 0, draggedElement);
            data.splice(dragged[0], 1);
        } else if (draggedOver.length === 2 && dragged.length === 2) {
            data[draggedOver[0]].actions.splice(draggedOver[1], 0, draggedElement);
            data[dragged[0]].actions.splice(dragged[1], 1);
        } else if (draggedOver.length === 1 && dragged.length === 1) {
            data.splice(dragged[0], 1);
            data.splice(draggedOver[0], 0, draggedElement);
        } 
    } else if (dragged[0] === draggedOver[0] && dragged.length === 2 && draggedOver.length === 1) {
        data[draggedOver[0]].actions.splice(dragged[1], 1);
        data.splice(draggedOver[0], 0, draggedElement);
    } else {
        if (dragged.length === 2 && draggedOver.length === 1) {
            data[dragged[0]].actions.splice(dragged[1], 1);
            data[draggedOver[0]].actions.splice(draggedOver[1] + 1, 0, draggedElement);
        } else if (draggedOver.length === 2 && dragged.length === 1) {
            data[draggedOver[0]].actions.splice(draggedOver[1] + 1, 0, draggedElement);
            data.splice(dragged[0], 1);
        } else if (draggedOver.length === 2 && dragged.length === 2) {
            data[dragged[0]].actions.splice(dragged[1], 1);
            data[draggedOver[0]].actions.splice(draggedOver[1], 0, draggedElement);
        } else if (draggedOver.length === 1 && dragged.length === 1) {
            data.splice(dragged[0], 1);
            data.splice(draggedOver[0], 0, draggedElement);
        }
    }

    return data;
}